import { Navigate } from 'react-router-dom';
import { getAdminToken } from '../lib/adminApi';

export const ProtectedAdminRoute = ({ children }) => {
  const token = getAdminToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};
